module.exports = __webpack_public_path__ + "static/image12.0ac641ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project1/image12.jpg
// module id = 129
// module chunks = 100667300852966 131627143932366